import React from 'react';
import styled from 'styled-components';

const DashboardContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Title = styled.h2`
  margin: 0 0 20px 0;
  color: #2c3e50;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const StatCard = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid ${props => props.color || '#3498db'};
`;

const StatTitle = styled.h3`
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 14px;
  text-transform: uppercase;
`;

const StatValue = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: ${props => props.color || '#3498db'};
`;

const Dashboard = () => {
  return (
    <DashboardContainer>
      <Title>대시보드</Title>
      
      {/* <StatsGrid>
        <StatCard color="#3498db">
          <StatTitle>총 제품 수</StatTitle>
          <StatValue color="#3498db">1,234</StatValue>
        </StatCard>
        
        <StatCard color="#2ecc71">
          <StatTitle>활성 사용자</StatTitle>
          <StatValue color="#2ecc71">567</StatValue>
        </StatCard>
        
        <StatCard color="#f39c12">
          <StatTitle>오늘 주문</StatTitle>
          <StatValue color="#f39c12">89</StatValue>
        </StatCard>
        
        <StatCard color="#e74c3c">
          <StatTitle>매출</StatTitle>
          <StatValue color="#e74c3c">₩12,345,678</StatValue>
        </StatCard>
      </StatsGrid> */}
      
      <div>
        <h3>최근 활동</h3>
        <p>최근 활동 내역이 여기에 표시됩니다.</p>
      </div>
    </DashboardContainer>
  );
};

export default Dashboard;